import React, { useState, useEffect, Component, ErrorInfo } from "react";
import { NewsEventModel } from "../../../domain/entities/NewsEventModel";
import NewsEventListComponents from "../../components/newseventComponents/NewsEventListComponents";
import { fetchNewsTop } from "../../../domain/usecases/fetchNews";
import SpinnerLoading from "../../components/spinnerLoading/SpinnerLoading";

// Error Boundary Component
class ErrorBoundary extends Component<{ children: React.ReactNode }, { hasError: boolean }> {
    constructor(props: { children: React.ReactNode }) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Error caught by boundary: ", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <div>Something went wrong with the News.</div>;
        }
        return this.props.children;
    }
}

const NewsEventPage: React.FC = () => {

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [news, setNews] = useState<NewsEventModel[]>([]);

    // Fetch news
    useEffect(() => {
        const fetchingNewsTop = async () => {
            try {
                const newsData = await fetchNewsTop();

                const newsDataItem = newsData.map((item) => item);

                setNews(newsDataItem);
            } catch (err) {
                console.error("Failed to fetch news:", err);
                setError("Failed to load news. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchingNewsTop();
    }, []);

    // Handle loading state
    if (loading) {
        return <SpinnerLoading />;
    }

    // Handle error state
    if (error) {
        return <div className="text-center text-red-500">{error}</div>;
    }

    return (
        <div>
            <ErrorBoundary>
                <NewsEventListComponents newsList={news} />
            </ErrorBoundary>
        </div>
    );
}

export default NewsEventPage;